import React from 'react';
import {Link, withRouter} from 'react-router-dom';
import _UserNav from './_UserNav.scss';
import DownloadApp from './DownloadApp.jsx';
import {connect} from 'react-redux';
import {ShowIf} from 'components/utils';
import {logout} from 'base/actions';
import {toastr} from 'react-redux-toastr';
import {UploadImage} from 'components/UI/Image';
import {UserMenu} from 'components/layouts/user/menu';

class UserNav extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  signout() {
    this.props.dispatch(logout()).then(res => {
      // go home
      toastr.success("Thành công", "Bạn đã đăng xuất thành công");
      this.props.history.push('/');
    })
  }

  toggleUserMenu() {
    let Search = document.getElementById('searchMobile');

    let userMenu = document.getElementById('userMenu');
    let userImage = document.getElementById('userImage');
    if(this.props.auth.isAuthenticated) {
      document.body.classList.toggle('open')
    }
    Search.classList.remove('open');
    userMenu.classList.toggle('open');
    userImage.classList.toggle('open');
  }

  render() {
    return (
      <div className='wrap-flexbox wrap-center'>
        <div className='user-img-wrap' onClick={this.toggleUserMenu.bind(this)} id='userImage'>
          <ShowIf condition={this.props.auth && this.props.auth.isAuthenticated && this.props.auth.user.avatar}>
            <UploadImage transform="crop" width={44} height={44} type='USER' image={this.props.auth.user ? this.props.auth.user.avatar : ''}/>
          </ShowIf>
          <ShowIf condition={!this.props.auth || !this.props.auth.isAuthenticated || !this.props.auth.user.avatar}>
            <div className='wrap-img'>
              <img src={require('assets/images/header/default-avata.jpg')} className='user-img' alt='' />
            </div>
          </ShowIf>

        </div>
        <ShowIf condition={!this.props.auth.isAuthenticated}>
          <div className='user-link-wrap un-authanticate' id='userMenu'>
            <div className='user-top-content'>
              <Link to='/signin' className='user-link'>Đăng nhập</Link>
              <Link to='/signup' className='user-link'>Đăng ký</Link>
            </div>
            <div className='content-show-mobile'>
              <DownloadApp/>
            </div>
          </div>
        </ShowIf>
        <ShowIf condition={this.props.auth.isAuthenticated}>
          <div className='user-link-wrap authanticate' id='userMenu'>
            <div className='content-show-mobile'>
              <UserMenu/>
              <DownloadApp/>
            </div>
            <div className='user-top-content'>
              <Link to='/dashboard' className='user-link-black'>Tài khoản của tôi</Link>
            </div>
            <div className='user-bottom-content'>
              <a href='javascript:void(0)' className='signout-link' onClick={this.signout.bind(this)}>Đăng xuất</a>
            </div>
          </div>
        </ShowIf>
      </div>
    )
  }
}

const bindStateToProps = state => {
  return {
    auth: state.auth
  }
}

export default withRouter(connect(bindStateToProps)(UserNav));



// WEBPACK FOOTER //
// ./components/layouts/master/sub-header/UserNav.jsx